import * as Sentry from '@sentry/nextjs';

import { form as formService } from '@boss/services/client';

import type { ContactFormValues } from '../../components/ContactForm';

/**
 * Client mutation to submit a form
 *
 * @async
 * @param {ContactFormValues} formData The form data
 * @returns {Promise}
 */
const submitForm = async (formData: ContactFormValues, locale: string) => {
  try {
    return await formService.sendClient(formData, locale);
  } catch (error) {
    console.error(error);

    Sentry.captureException(error, {
      tags: {
        type: 'Submitting form',
      },
    });

    throw error;
  }
};

export { submitForm };
